export default __webpack_public_path__ + "static/media/Photo 5 - BR - inertie thermique.9b3b1d7d.jpg";